import { render, staticRenderFns } from "./CollectionSuggestion.vue?vue&type=template&id=64786433&scoped=true&"
import script from "./CollectionSuggestion.vue?vue&type=script&lang=js&"
export * from "./CollectionSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSuggestion.vue?vue&type=style&index=0&id=64786433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64786433",
  null
  
)

export default component.exports